<template>
    <div>
        <div class="d-flex items-center gap-3 px-4 flex-wrap">
            <div class="position-relative cursor-pointer" v-for="(img, index) in imageItems" :key="index">
                <a :href="img.document" data-fancybox="gallery">
                    <img :src="img.document" width="150" height="150" class="contact-img" />
                </a>
                <svg class="delete-contact-img" @click="setImageData(img.id)" width="30" height="30" viewBox="0 0 30 30"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="30" rx="8" fill="#F5F5F5" />
                    <path
                        d="M15.2873 7C15.9325 6.99991 16.5544 7.241 17.0309 7.67594C17.5074 8.11088 17.8041 8.70825 17.8628 9.35075H21.8694C22.0481 9.3508 22.2201 9.41868 22.3506 9.54066C22.4812 9.66264 22.5606 9.82964 22.5728 10.0079C22.5849 10.1862 22.529 10.3624 22.4163 10.501C22.3035 10.6396 22.1423 10.7303 21.9653 10.7546L21.8694 10.7612H21.3212L20.1299 21.0857C20.0768 21.544 19.8571 21.9668 19.5126 22.2737C19.1681 22.5805 18.7228 22.7501 18.2615 22.75H12.3131C11.8518 22.7501 11.4065 22.5805 11.062 22.2737C10.7175 21.9668 10.4978 21.544 10.4448 21.0857L9.25248 10.7612H8.70522C8.53481 10.7612 8.37016 10.6995 8.24172 10.5875C8.11329 10.4754 8.02976 10.3207 8.00658 10.1519L8 10.056C8.00001 9.88555 8.06172 9.7209 8.17374 9.59247C8.28575 9.46403 8.44048 9.38051 8.60931 9.35733L8.70522 9.35075H12.7118C12.7705 8.70825 13.0672 8.11088 13.5437 7.67594C14.0202 7.241 14.6421 6.99991 15.2873 7ZM13.8769 12.8769C13.6465 12.8769 13.4537 13.0226 13.4142 13.2144L13.4067 13.2887V19.048L13.4142 19.1214C13.4537 19.3132 13.6465 19.459 13.8769 19.459C14.1072 19.459 14.3 19.3132 14.3395 19.1214L14.347 19.0471V13.2897L14.3395 13.2144C14.3 13.0236 14.1072 12.8769 13.8769 12.8769ZM16.6978 12.8769C16.4674 12.8769 16.2746 13.0226 16.2351 13.2144L16.2276 13.2887V19.048L16.2351 19.1214C16.2746 19.3132 16.4674 19.459 16.6978 19.459C16.9281 19.459 17.1209 19.3132 17.1604 19.1214L17.1679 19.0471V13.2897L17.1604 13.2144C17.1209 13.0236 16.9281 12.8778 16.6978 12.8778V12.8769ZM15.2873 8.41045C14.7184 8.41045 14.2436 8.81478 14.1354 9.35075H16.4392C16.3301 8.81478 15.8562 8.41045 15.2873 8.41045Z"
                        fill="#FF0000" />
                </svg>

                <svg width="30" height="30" class="update-contact-img"
                    @click="setActionImageData(img.id, $t('imagesSection.moveToDocuments'))"
                    viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="30" rx="8" fill="#F5F5F5" />
                    <path
                        d="M12.175 19H6C5.71667 19 5.47934 18.904 5.288 18.712C5.09667 18.52 5.00067 18.2827 5 18C4.99934 17.7173 5.09534 17.48 5.288 17.288C5.48067 17.096 5.718 17 6 17H12.175L10.3 15.125C10.1167 14.9417 10.025 14.7127 10.025 14.438C10.025 14.1633 10.1167 13.9257 10.3 13.725C10.5 13.525 10.7377 13.425 11.013 13.425C11.2883 13.425 11.5257 13.525 11.725 13.725L15.3 17.3C15.4 17.4 15.471 17.5083 15.513 17.625C15.555 17.7417 15.5757 17.8667 15.575 18C15.5743 18.1333 15.5537 18.2583 15.513 18.375C15.4723 18.4917 15.4013 18.6 15.3 18.7L11.7 22.3C11.5 22.5 11.2667 22.596 11 22.588C10.7333 22.58 10.5 22.4757 10.3 22.275C10.1167 22.075 10.021 21.8417 10.013 21.575C10.005 21.3083 10.1007 21.075 10.3 20.875L12.175 19ZM17.825 13L19.7 14.875C19.8833 15.0583 19.975 15.2877 19.975 15.563C19.975 15.8383 19.8833 16.0757 19.7 16.275C19.5 16.475 19.2627 16.575 18.988 16.575C18.7133 16.575 18.4757 16.475 18.275 16.275L14.7 12.7C14.6 12.6 14.5293 12.4917 14.488 12.375C14.4467 12.2583 14.4257 12.1333 14.425 12C14.4243 11.8667 14.4453 11.7417 14.488 11.625C14.5307 11.5083 14.6013 11.4 14.7 11.3L18.3 7.70002C18.5 7.50002 18.7333 7.40435 19 7.41302C19.2667 7.42168 19.5 7.52568 19.7 7.72502C19.8833 7.92502 19.9793 8.15835 19.988 8.42502C19.9967 8.69168 19.9007 8.92502 19.7 9.12502L17.825 11H24C24.2833 11 24.521 11.096 24.713 11.288C24.905 11.48 25.0007 11.7173 25 12C24.9993 12.2827 24.9033 12.5203 24.712 12.713C24.5207 12.9057 24.2833 13.0013 24 13H17.825Z"
                        fill="#FEC701" />
                </svg>

            </div>
        </div>
        <input ref="imageFile" type="file" name="imageFile" v-on:change="handleImageUpload" accept="image/*"
            class="d-none" multiple />
        <DeleteModal v-if="showActionImagePopup" @confirm="deleteImageItem($event)" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import { Fancybox } from "@fancyapps/ui";
import DeleteModal from "@/components/DeleteModal.vue";
export default {
    name: "ImagesSection",
    props: ['id', 'addImageFiles', 'imageItems', 'deleteImageFile', "setActionImageData"],
    components: { DeleteModal },
    data() {
        return {
            showActionImagePopup: false,
            imgID: null
        }
    },
    computed: {
        ...mapGetters(["userCompany"]),
    },
    methods: {
        ...mapActions(["setLoader", "setNotification"]),
        setImageData(id) {
            this.showActionImagePopup = true
            this.imgID = id
        },
        async deleteImageItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteImageFile({
                        accidentID: this.id,
                        documentID: `${this.imgID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('imagesSection.imageDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.imgData = null
                    this.showActionImagePopup = false
                    this.$emit("updateImages")
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.showActionImagePopup = false
                this.setLoader(false)
            }
        },
        async handleImageUpload() {
            const files = this.$refs.imageFile.files;

            if (!files.length) return;

            this.setLoader(true);

            try {
                const uploadPromises = Array.from(files).map(file => {
                    const formData = new FormData();
                    formData.append('document', file);
                    formData.append('gallery', true);
                    return this.addImageFiles({ id: this.id, payload: formData });
                });

                await Promise.all(uploadPromises);

                this.setLoader(false);
                await this.setNotification({
                    msg: this.$t('imagesSection.imagesUploaded'),
                    type: "success",
                    color: "green",
                });
                this.$emit("updateImages")
            } catch (error) {
                console.log(error)
                this.setLoader(false);
            }
        },
        openImageSection() {
            this.$refs.imageFile.click();
        }
    },
    mounted() {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Thumbs: {
                autoStart: true,
            },
        });
    }
}
</script>
<style scoped>
.contact-img {
    border: 1px solid #EEEEEE;
    border-radius: 8px;
}

.delete-contact-img {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    cursor: pointer;
    color: black;
}

.update-contact-img {
    position: absolute;
    right: 10px;
    top: 45px;
    z-index: 1;
    cursor: pointer;
    color: black;
}
</style>